(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["phaze-fit-ui"] && !Shopify.designMode) return;
  try {
    (() => {
  if (customElements.get('phaze-fit-form')) return;
  let latestProductId = '';
  let submitting = false;
  const refreshAll = () => {
    document.querySelectorAll('phaze-fit-form').forEach(form => form.refresh());
    document.querySelectorAll('phaze-cart-matches').forEach(matches => matches.refresh());
  };
  document.addEventListener('cart:update', event => {
    if (!event.detail?.data?.didError && event.detail?.data?.productId) {
      latestProductId = String(event.detail.data.productId);
    }
    queueMicrotask(refreshAll);
  }, { capture: true });

  class PhazeFitPicker extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('change', () => this.refresh(), { signal: this.controller.signal });
      this.refresh();
    }
    disconnectedCallback() { this.controller?.abort(); }
    get variants() {
      try { return JSON.parse(this.querySelector('[data-pw-variants]')?.textContent || '[]'); }
      catch { return []; }
    }
    get input() {
      return this.querySelector('select[data-pw-variant], input[type="hidden"][data-pw-variant], input[data-pw-variant]:checked');
    }
    get selected() {
      const id = this.input?.value;
      return this.variants.find(variant => String(variant.id) === id);
    }
    selectVariant(id) {
      if (!this.variants.some(variant => String(variant.id) === String(id))) return;
      this.querySelectorAll('[data-pw-variant]').forEach(input => {
        if (input.type === 'radio') input.checked = input.value === String(id);
        else input.value = String(id);
      });
      this.refresh();
    }
    refresh() {
      const variant = this.selected || this.variants.find(item => item.available) || this.variants[0];
      const price = this.querySelector('[data-pw-price]');
      if (price && variant) price.textContent = variant.money;
      const choice = this.querySelector('[data-pw-choice]');
      if (choice && this.input?.dataset.label) choice.textContent = this.input.dataset.label;
    }
  }

  class PhazeCartMatches extends HTMLElement {
    connectedCallback() { this.refresh(); }
    refresh() {
      const forms = Array.from(this.querySelectorAll('phaze-fit-form'));
      const selected = forms.find(form => form.dataset.ownerId === latestProductId) || forms[0];
      forms.forEach(form => { form.hidden = form !== selected; });
      this.hidden = !selected;
    }
  }

  class PhazeFitForm extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.addEventListener('change', () => this.refresh(), { signal });
      this.addEventListener('submit', event => this.submit(event), { signal });
      if (this.dataset.mode === 'set') {
        document.addEventListener('variant:update', event => {
          if (String(event.detail?.data?.productId) !== this.dataset.productId) return;
          this.querySelector('phaze-fit-picker[data-primary="true"]')?.selectVariant(event.detail?.resource?.id);
          this.refresh();
        }, { signal });
      }
      this.refresh();
    }
    disconnectedCallback() { this.controller?.abort(); }
    get pickers() { return Array.from(this.querySelectorAll('phaze-fit-picker')); }
    refresh() {
      const pickers = this.pickers;
      const ready = pickers.length > 0 && pickers.every(picker => picker.selected?.available);
      const button = this.querySelector('[data-pw-add]');
      if (button) {
        button.disabled = submitting || !ready;
        button.setAttribute('aria-busy', this.busy ? 'true' : 'false');
      }
      const label = this.querySelector('[data-pw-button-label]');
      if (label) label.textContent = this.busy ? this.dataset.loading : ready ? this.dataset.ready : this.dataset.choose;
      const total = this.querySelector('[data-pw-total]');
      if (total) {
        const amount = pickers.reduce((sum, picker) => {
          picker.refresh();
          const variant = picker.selected || picker.variants.find(item => item.available) || picker.variants[0];
          return sum + (variant?.price || 0);
        }, 0);
        try {
          total.textContent = new Intl.NumberFormat(this.dataset.locale, {
            style: 'currency', currency: this.dataset.currency, currencyDisplay: 'code'
          }).format(amount / 100);
        } catch { total.textContent = (amount / 100).toFixed(2) + ' ' + this.dataset.currency; }
      }
    }
    async submit(event) {
      event.preventDefault();
      event.stopPropagation();
      if (submitting || !this.pickers.every(picker => picker.selected?.available)) return;
      const items = this.pickers.map(picker => ({ id: picker.selected.id, quantity: 1 }));
      const sourceId = this.querySelector('form')?.id || 'phaze-fit';
      const root = window.Shopify?.routes?.root || '/';
      const status = this.querySelector('[data-pw-status]');
      if (status) { status.textContent = ''; status.dataset.error = 'false'; }
      this.busy = true;
      submitting = true;
      refreshAll();
      let events;
      let added = false;
      try {
        events = window.PhazeMateriaEvents;
        const sections = [...new Set(Array.from(document.querySelectorAll('cart-items-component'))
          .map(component => component.dataset.sectionId).filter(Boolean))].slice(0, 5);
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items, sections, sections_url: window.location.pathname })
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
        }
        added = true;
        const cart = await fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
          .then(response => response.ok ? response.json() : undefined).catch(() => undefined);
        document.dispatchEvent(new events.CartAddEvent(cart, sourceId, {
          source: 'phaze-fit',
          productId: this.dataset.productId,
          itemCount: items.length,
          sections: result.sections
        }));
        if (status && this.isConnected) status.textContent = this.dataset.added;
        if (!document.querySelector('cart-notification, cart-drawer')) window.location.assign(root + 'cart');
      } catch (error) {
        if (status && this.isConnected) {
          status.dataset.error = 'true';
          status.textContent = error.message || this.dataset.error;
        }
        if (events && !added) {
          const cart = await fetch(root + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(response => response.ok ? response.json() : undefined).catch(() => undefined);
          if (cart) document.dispatchEvent(new events.CartUpdateEvent(cart, sourceId, { source: 'phaze-fit', didError: true }));
        }
      } finally {
        submitting = false;
        this.busy = false;
        refreshAll();
      }
    }
  }
  customElements.define('phaze-fit-picker', PhazeFitPicker);
  customElements.define('phaze-cart-matches', PhazeCartMatches);
  customElements.define('phaze-fit-form', PhazeFitForm);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["phaze-migrated-fit-rail"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('phaze-fit-rail')) {
    customElements.define('phaze-fit-rail', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.track = this.querySelector('[data-rail-track]');
        this.previousButton = this.querySelector('[data-rail-previous]');
        this.nextButton = this.querySelector('[data-rail-next]');
        if (!this.track || !this.previousButton || !this.nextButton) return;
        const signal = this.controller.signal;
        this.previousButton.addEventListener('click', () => this.move(-1), { signal });
        this.nextButton.addEventListener('click', () => this.move(1), { signal });
        this.addEventListener('click', event => this.onCardClick(event), { signal });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') this.closePickers();
        }, { signal });
        document.addEventListener('click', event => {
          if (!this.contains(event.target)) this.closePickers();
        }, { signal });
        this.track.addEventListener('scroll', () => this.update(), { signal, passive: true });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.track);
        requestAnimationFrame(() => this.update());
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
      }

      move(direction) {
        const card = this.track.querySelector('.pw-fit-rail__card');
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        const distance = card ? card.getBoundingClientRect().width + gap : this.track.clientWidth * 0.75;
        this.track.scrollBy({ left: distance * direction, behavior: 'smooth' });
      }

      onCardClick(event) {
        const variantButton = event.target.closest('[data-variant-id]');
        if (variantButton && this.contains(variantButton)) {
          event.preventDefault();
          event.stopPropagation();
          this.addVariant(variantButton);
          return;
        }

        const toggle = event.target.closest('[data-picker-toggle]');
        if (!toggle || !this.contains(toggle)) return;
        event.preventDefault();
        event.stopPropagation();
        const card = toggle.closest('.pw-fit-rail__card');
        const willOpen = card?.dataset.pickerOpen !== 'true';
        this.closePickers(card);
        if (!card) return;
        card.dataset.pickerOpen = String(willOpen);
        toggle.setAttribute('aria-expanded', String(willOpen));
        toggle.setAttribute('aria-label', willOpen ? toggle.dataset.closeLabel : toggle.dataset.openLabel);
      }

      closePickers(except) {
        this.querySelectorAll(".pw-fit-rail__card[data-picker-open='true']").forEach(card => {
          if (card === except) return;
          card.dataset.pickerOpen = 'false';
          const toggle = card.querySelector('[data-picker-toggle]');
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
            toggle.setAttribute('aria-label', toggle.dataset.openLabel);
          }
        });
      }

      async addVariant(button) {
        const card = button.closest('.pw-fit-rail__card');
        if (!card || card.dataset.loading === 'true' || button.dataset.available !== 'true') return;
        const status = card.querySelector('[data-card-status]');
        const root = window.Shopify?.routes?.root || '/';
        card.dataset.loading = 'true';
        card.setAttribute('aria-busy', 'true');
        card.querySelectorAll('[data-variant-id]').forEach(control => { control.disabled = true; });
        if (status) {
          status.dataset.error = 'false';
          status.textContent = this.dataset.adding;
        }

        let events;
        let added = false;
        try {
          events = window.PhazeMateriaEvents;
          const sections = [...new Set(Array.from(document.querySelectorAll('cart-items-component'))
            .map(component => component.dataset.sectionId).filter(Boolean))].slice(0, 5);
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({
              items: [{ id: button.dataset.variantId, quantity: 1 }],
              sections,
              sections_url: window.location.pathname
            })
          });
          const result = await response.json();
          if (!response.ok || result.status >= 400) {
            throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
          }
          added = true;
          const cart = await fetch(root + 'cart.js', {
            credentials: 'same-origin',
            headers: { Accept: 'application/json' }
          }).then(cartResponse => cartResponse.ok ? cartResponse.json() : undefined).catch(() => undefined);
          document.dispatchEvent(new events.CartAddEvent(cart, `phaze-fit-rail-${button.dataset.variantId}`, {
            source: 'phaze-fit-rail',
            productId: button.dataset.productId,
            itemCount: 1,
            sections: result.sections
          }));
          if (status && this.isConnected) status.textContent = this.dataset.added;
          card.dataset.pickerOpen = 'false';
          const toggle = card.querySelector('[data-picker-toggle]');
          if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
            toggle.setAttribute('aria-label', toggle.dataset.openLabel);
          }
          button.blur();
          if (!document.querySelector('cart-notification, cart-drawer')) window.location.assign(root + 'cart');
        } catch (error) {
          if (status && this.isConnected) {
            status.dataset.error = 'true';
            status.textContent = error.message || this.dataset.error;
          }
          if (events && !added) {
            const cart = await fetch(root + 'cart.js', {
              credentials: 'same-origin',
              headers: { Accept: 'application/json' }
            }).then(cartResponse => cartResponse.ok ? cartResponse.json() : undefined).catch(() => undefined);
            if (cart) {
              document.dispatchEvent(new events.CartUpdateEvent(cart, `phaze-fit-rail-${button.dataset.variantId}`, {
                source: 'phaze-fit-rail',
                didError: true
              }));
            }
          }
        } finally {
          card.dataset.loading = 'false';
          card.setAttribute('aria-busy', 'false');
          card.querySelectorAll('[data-variant-id]').forEach(control => {
            control.disabled = control.dataset.available !== 'true';
          });
        }
      }

      update() {
        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const scrollable = maxScroll > 2;
        this.dataset.scrollable = String(scrollable);
        this.previousButton.disabled = !scrollable || this.track.scrollLeft <= 2;
        this.nextButton.disabled = !scrollable || this.track.scrollLeft >= maxScroll - 2;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
